<footer class="footer" color="primary">
  <div class="content-foot" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="center center" class="esconder">
      <button mat-icon-button>
        <img class="img-button" src="assets/images/iconos pag-05.png" alt="phone">
      </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="principal">
      <button mat-icon-button>
        <img class="img-button" src="assets/images/iconos pag-01.png" alt="mail">
      </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="esconder">
      <button mat-icon-button>
        <img class="img-button" src="assets/images/iconos pag-06.png" alt="mail">
      </button>
    </div>
  </div>
</footer>
